module.exports = __webpack_public_path__ + "static/img/group-6.50afc53.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Gotit/group-6.png
// module id = gAoE
// module chunks = 0